<header class="header">
  <div class="header-content">
    <h1>Benvenuto nella Lista di Tile</h1>
    <nav class="menu">
      <ul>
        <li><a href="#home">Home</a></li>
        <li><a href="#about">Chi Siamo</a></li>
        <li><a href="#services">Servizi</a></li>
        <li><a href="#contact">Contatti</a></li>
      </ul>
    </nav>
  </div>
</header>


<div class="search-container">
  <div class="search-wrapper">
    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <input 
      type="text" 
      placeholder="Cerca..." 
      [(ngModel)]="searchText" 
      (input)="filterTiles()" 
      class="search-input" 
    />
  </div>
</div>

<div class="categories-container">
  <div class="categories-wrapper">
    <div class="category" *ngFor="let category of categories">
      {{ category }}
    </div>
  </div>
</div>

<div class="tile-container">
  <div class="tile" *ngFor="let tile of tiles">
    <img *ngIf="tile.image" [src]="tile.image" alt="{{ tile.title }}" class="tile-image" />
    <h3 class="tile-title">{{ tile.title }}</h3>
    <p class="tile-description">{{ tile.description }}</p>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="footer-buttons">
      <button class="footer-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="footer-icon">
          <path d="M3 12l7-7 7 7M12 5v14"></path>
        </svg>
        <span>Home</span>
      </button>
      <button class="footer-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="footer-icon">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>Info</span>
      </button>
      <button class="footer-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="footer-icon">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        <span>Download</span>
      </button>
    </div>
  </div>
</footer>